import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  InteractionFilter,
  PageResponse,
  ReportByFilter,
  UserFilter,
} from '@app/models';
import { ReportInteractionResponse } from 'app/_models/report-interaction-response';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { BaseServiceClass } from '../baseService.service';

@Injectable({ providedIn: 'root' })
export class ReportServiceV2 extends BaseServiceClass<any> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v2/reports');
  }

  public generateInteractionReport(
    filter: ReportByFilter | InteractionFilter,
    type: String
  ) {
    return this.httpService.post(
      `${this.entity_url}/interactions/${type}`,
      filter
    );
  }

  public generateAgentSummaryReport(
    filter: InteractionFilter,
    type: string
  ): Observable<any> {
    return this.httpService.post(
      `${this.entity_url}/agent-summary/${type}`,
      filter
    );
  }

  public generateContestationReport(filter: ReportByFilter, type: String) {
    return this.httpService.post(
      `${this.entity_url}/contestations/${type}`,
      filter
    );
  }

  public generateMonitorInteractionsReport(
    filter: ReportByFilter,
    type: String
  ) {
    return this.httpService.post(
      `${this.entity_url}/monitor-interactions/${type}`,
      filter
    );
  }

  public generateInteractionCommentReport(
    filter: ReportByFilter,
    type: String
  ): Observable<PageResponse<ReportInteractionResponse>> {
    return this.httpService.post<PageResponse<ReportInteractionResponse>>(
      `${this.entity_url}/interactions-comments/${type}`,
      filter
    );
  }

  public generateUsersReport(filter: UserFilter) {
    return this.httpService.post(`${this.entity_url}/users`, filter);
  }

  public getMyReports(filters: any): Observable<any> {
    let options = { params: <any>_.omitBy(filters, _.isNil) };
    return this.httpService.get<any>(`${this.entity_url}/my-reports`, options);
  }

  public cancelReport(id: number): Observable<any> {
    return this.httpService.post(`${this.entity_url}/cancel/${id}`, {});
  }

  public getInteractionsCommentsReport(
    filter: ReportByFilter
  ): Observable<any> {
    return this.httpService.post<any>(
      `${this.entity_url}/interactions-comments`,
      filter
    );
  }
}
